/* eslint-disable jsx-a11y/anchor-is-valid */
import ProductHighlightTextProvider from './hooks/useProductHighlightText';

import { ProductHighlightTextProps } from './@types/ProductHighlightTextProps';

const ProductHighlightText = (props: ProductHighlightTextProps) => {
	const textMessage = props.message?.replace('{highlightName}', 'Lançamentos');

	const renderTokens = () => {
		if (props.blockClass) {
			return `vtex-product-highlights-2-x-productHighlightText--${props.blockClass}`;
		}
	};

	const renderElement = () => {
		if (props.link) {
			return (
				<a
					data-selection={props.componentId}
					className={`productHighlightText productHighlightText--${props.blockClass} vtex-product-highlights-2-x-productHighlightText ${renderTokens()}`}
				>
					{textMessage}
				</a>
			);
		}

		return (
			<span
				data-selection={props.componentId}
				className={`productHighlightText productHighlightText--${props.blockClass} vtex-product-highlights-2-x-productHighlightText ${renderTokens()}`}
			>
				{textMessage}
			</span>
		);
	};

	return <ProductHighlightTextProvider {...props}>{renderElement()}</ProductHighlightTextProvider>;
};

export default ProductHighlightText;
